module.exports = __webpack_public_path__ + "img/design.8f1c9708.png";